import { supabase } from "@/integrations/supabase/client";

// Shape of data returned by the "get-user-to-delete" function
export interface UserDeleteInfo {
  userName: string;
  has_active_subscription: boolean;
  has_trials: boolean;
  has_referrals: boolean;
}

/**
 * Fetches information needed before deleting a user.
 * Returns a UserDeleteInfo object, null if no data, or throws on error.
 */
export const getUserDeleteInfo = async (
  userId: string
): Promise<UserDeleteInfo | null> => {
  try {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session) {
      console.error("No active session found for deleteUserUtils");
      return null;
    }

    const { data, error } = await supabase.functions.invoke(
      `get-user-to-delete?userId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${session.access_token}`,
        },
        method: "GET",
      }
    );

    if (error) {
      console.error("Error invoking get-user-to-delete:", error);
      return null;
    }

    // If the function returns no payload
    if (!data) {
      return null;
    }

    // Validate shape at runtime if desired
    return data as UserDeleteInfo;
  } catch (err) {
    console.error("Exception during getUserDeleteInfo:", err);
    return null;
  }
};


export const deleteUserViaEdge = async (userId: string): Promise<boolean> => {
    try {
        const {
          data: { session },
        } = await supabase.auth.getSession();
        if (!session) {
          console.error("No active session found for deleteUserUtils");
          return null;
        }
    
        const { data, error } = await supabase.functions.invoke(
          `delete-user`,
          {
            headers: {
              Authorization: `Bearer ${session.access_token}`,
            },
            method: "POST",
            body: { 
                userId: userId
            }
          }
        );
    
        if (error) {
          console.error("Error invoking delete-user:", error);
          return false;
        }
    
        return true;
      } catch (err) {
        console.error("Exception during delete user:", err);
        return false;
      }
}